import GridOnIcon from '@mui/icons-material/GridOn';
import { Box, Divider } from '@mui/material';

import DxfIcon from 'assets/DxfIcon';
import GraphIcon from 'assets/GraphIcon';
import ListIcon from 'assets/ListIcon';
import ButtonIcon from 'components/ButtonIcon';
import ButtonIconSvg from 'components/ButtonIconSvg';
import NewFeatureBadge from 'components/NewFeatureBadge';
import CadToDxfHelpDialog from 'pages/Revisions/v4/components/CadToDxfHelpDialog';
import { useState } from 'react';

const RevisionFilter = ({
	changeView,
	view,
	isGraphView,
	isGraphAllowed,
	showCadDxf = false,
}: any) => {
	const [cadDxfOpen, setCadDxfOpen] = useState(false);

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				gap: "5px"
			}}
		>
			{showCadDxf && (
				<>
					<NewFeatureBadge>
						<ButtonIconSvg
							isActive={cadDxfOpen}
							primaryOnInteract
							onClick={() => setCadDxfOpen(true)}
						>
							<DxfIcon />
						</ButtonIconSvg>
					</NewFeatureBadge>
					<CadToDxfHelpDialog
						open={cadDxfOpen}
						onClose={() => setCadDxfOpen(false)}
					/>
				</>
			)}
			{view == 'Table' && (
				<>
					<ButtonIconSvg isActive={isGraphView} onClick={() => changeView('Graph')}>
						<GraphIcon />
					</ButtonIconSvg>
				</>
			)}
			{/* hide view table if graph is allowed */}
			{isGraphAllowed && (
				<>
					<ButtonIcon isActive={view == 'Table'} onClick={() => changeView('Table')} >
						<GridOnIcon sx={{ fontSize: '35px', m: 0.5 }} />
					</ButtonIcon>
					<Divider orientation="vertical" variant="middle" flexItem />
				</>
			)}
			<ButtonIconSvg isActive={view == 'List'} onClick={() => changeView('List')}>
				<ListIcon />
			</ButtonIconSvg>
		</Box>
	);
};

export default RevisionFilter;
